import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Elements } from '@stripe/react-stripe-js'
import UpdateForm from './UpdateForm'
import PageModal from '../PageModal'
import { useAppContext } from '../../../libs/contextLib'
import { getPaymentMethods } from '../../../utils/requests/paymentMethodsAPI'
import './create-payment-method-modal.scss'

const CreatePaymentMethodModal = (props) => {
  const { t } = useTranslation()
  const { stripe } = useAppContext()
  const { closeModal, clientSecret } = props
  const [paymentMethodIdToDelete, setPaymentMethodIdToDelete] = useState(null)
  const options = {
    clientSecret: clientSecret,
  }

  useEffect(() => {
    getPaymentMethods().then((response) => {
      if (response.length > 0) {
        const defaultPaymentMethod = response[0]
        setPaymentMethodIdToDelete(defaultPaymentMethod?.id)
      }
    })
  }, [])

  return (
    <PageModal toggle className="create-payment-method-modal" title={t('account_context.add_payment_method')} onToggle={() => closeModal()}>
      <div className="create-payment-method-content">
        <Elements stripe={stripe} options={options}>
          <UpdateForm paymentMethodIdToDelete={paymentMethodIdToDelete} closeModal={closeModal} />
        </Elements>
      </div>
    </PageModal>
  )
}

export default CreatePaymentMethodModal
